import { Table } from '@billy/design-system'
import { ReactElement } from 'react'

import { TableIds } from '../../../../../../enums/tableIds'
import { useSalesOverviewReport } from '../../../../hooks/salesOverviewReport/useSalesOverviewReport'
import { useSalesOverviewReportTableColumns } from '../../../../hooks/salesOverviewReport/useSalesOverviewReportTableColumns'
import { useSalesOverviewReportTableData } from '../../../../hooks/salesOverviewReport/useSalesOverviewReportTableData'

export const SalesOverviewReportTable = (): ReactElement => {
  const { isLoading } = useSalesOverviewReport()
  const tableData = useSalesOverviewReportTableData()
  const tableColumns = useSalesOverviewReportTableColumns()

  return (
    <Table
      columns={tableColumns}
      data={tableData}
      id={TableIds.SalesOverviewReport}
      isLoading={isLoading}
      withColumnsFiltering={false}
      withStickyHeader
      withPagination={false}
      withSkeletonView
      withFooter
    />
  )
}
